import React, { useState, useEffect } from "react";
import KioskFeature1 from "../Assests/kioskImage/Kiosk Feature-1.png";
import KioskFeature2 from "../Assests/kioskImage/Kiosk Feature-2.png";
import KioskFeature3 from "../Assests/kioskImage/Kiosk Feature-3.png";
import KioskFeature4 from "../Assests/kioskImage/Kiosk Feature-4.png";
import KioskFeature5 from "../Assests/kioskImage/Kiosk Feature-5.png";

const features = [
  {
    image: KioskFeature1,
    title: "Prakriti & Vikriti Assessment",
    subtitle: "Wellness Mapping",
    description:
      "Discover your unique natural constitution and uncover any imbalances to tailor a personalized approach for optimal health and well-being",
  },
  {
    image: KioskFeature2,
    title: "Digital Device Readings (BCA, BP, Pulse, Blood Oxygen Level)",
    subtitle: "Vital Monitoring",
    description:
      "Providing Accurate, Real-time Monitoring of Your Key Vital Signs to Support Proactive Health Management and Early Detection of Potential Issues",
  },
  {
    image: KioskFeature3,
    title: "Teleconsultation with Ayurveda Experts",
    subtitle: "Ayur Doc",
    description:
      "Connect with qualified Ayurvedic doctors for personalized consultations, advice, and ongoing support for your health journey",
  },
  {
    image: KioskFeature4,
    title: "Personalized Recommendations",
    subtitle: "Holistic Care",
    description:
      "Receive tailored Ayurvedic dietary & lifestyle suggestions (Yoga, Meditation) & herbal supplement to enhance your well-being & balance your imbalances",
  },
  {
    image: KioskFeature5,
    title: "Digital Reports",
    subtitle: "Health Reports",
    description:
      "Detailed Prakriti & Vikriti Assessment Results, with Personalized Recommendations on Diet, Recipes, and Lifestyle Practices for Holistic Health Well-being",
  },
];

const Fourth = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % features.length);
    }, 9000); 
    return () => clearInterval(intervalId);
  }, []);

  const currentFeature = features[currentIndex];

  return (
    <div className="feature-background">
      <div className="feature-container active">
        <div className="feature-box image-box">
          <img
            src={currentFeature.image}
            alt={`Feature ${currentIndex + 1}`}
          />
        </div>
        <div className="feature-box content-box">
          <div className="feature-box-content">
            <p className="feature-content-button1">Features</p>
            <p className="feature-content">{currentFeature.title}</p>
            <p className="feature-content-1">{currentFeature.subtitle}</p>
            <p className="feature-content-2">{currentFeature.description}</p>
            <div className="flex items-center gap-3 feature-content-3 mt-4">
              {features.map((_, index) => (
                <div
                  key={index}
                  className={
                    currentIndex === index
                      ? "w-[86px] h-1.5 bg-[#1d8588] rounded-lg"
                      : "w-1.5 h-1.5 bg-[#d9d9d9] rounded-lg"
                  }
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      
      
    </div>
  );
};

export default Fourth;
